export default __webpack_public_path__ + "static/media/NeueHaasDisplay-Roman.e51f1f13.woff";